import React, { useCallback } from 'react';
import EditAndRateDriver from './EditAndRateDriver';

const AddDriver = ({ actions, policy, effectiveDate, onCancel, onComplete, save, onError, setLoading, onSave, onExit, onClearRate, rate, setRate }) => {
	const _onSave = useCallback(
		async (driverData, _rate) => {
			driverData.driverNum = null;
			await onSave(driverData, _rate || rate);
		},
		[onSave, rate]
	);

	const onRate = useCallback(
		async (data) => {
			try {
				setLoading('Generating rate');
				const result = await actions.rateDriver({ policyId: policy.policyId, policyNumber: policy.policyNumber, endorsementPolicyImageNumber: rate?.policyImageNum, driverNum: rate?.driverNum, effectiveDate, ...data });

				const _rate = { ...result.response, email: { action: 'Added', name: `${data.firstName} ${data.lastName}` } };

				setRate(_rate);
				await _onSave(data, _rate);
				setLoading(null);
			} catch (error) {
				setLoading(null);
				onError(error.error);
			}
		},
		[setLoading, actions, policy, rate, effectiveDate, _onSave, onError, setRate]
	);

	const onRateConfirm = useCallback(() => {
		onComplete(rate);
	}, [onComplete, rate]);

	return <EditAndRateDriver onSave={_onSave} onExit={onExit} onCancel={onCancel} setLoading={setLoading} save={save} isAdd onRate={onRate} onRateConfirm={onRateConfirm} policy={policy} effectiveDate={effectiveDate} rate={rate} onClearRate={onClearRate} />;
};

export default AddDriver;
